'use strict';

import {EvaluationBaseCtrl} from "../applications/evaluationbasectrl.js";
import {evaluationAwrcriModel} from "../../models/evaluationawrcrimodel.js";
import {evlCriterionModel} from "../../models/evlcriterionmodel.js";

export class InvitationEvaluationAwrcriCtrl extends EvaluationBaseCtrl
{
	
	postConstruct(){
		this.cfg.esfaFieldPermission = this.jsDataService.get('cfgEsfaFieldPermission', false);
		let evaluation = this.jsDataService.get('evaluation', {});
		this.evaluation = new evaluationAwrcriModel(evaluation, this.$filter, this.jsDataService);
		
		this.changeUrl = this.jsDataService.get('changeUrl', '');
		this.cancelChangeUrl = this.jsDataService.get('cancelChangeUrl', '');
		this.pendingUrl = this.jsDataService.get('pendingUrl', '');
		this.confirmUrl = this.jsDataService.get('confirmUrl', '');
//		this.showRequire = true;
	}
	
	getCriteria(){
//		return Object.values(this.evaluation.data_value.criteria);
//console.log(this.evaluation.form_data.getCriteriaList())
		return this.evaluation.form_data.getCriteriaList();
	}
	
//	autosavePostFields(){
//		return {
//			criteria: this.evaluation.data_value.getCriteriaData(),
//			fields: this.evaluation.data_value.getFieldsData(),
//			budgetReduction: this.evaluation.data_value.budgetReduction,
////			total: this.evaluation.data_value.total,
////			attachments: this.attachments
//		};
//	}
	
	
	
	fixPrecision(obj, field){
		if(!isNaN(obj[field]) && obj[field]){
			obj[field] = Number(obj[field].toFixed(2));
		}
	}


	cancel = function(){
		const url = this.jsDataService.get('previewUrl');
		if(url){
			this.$scope.goUrl(url);
		}
	};

	save = function(){
		this.saveData();
	};

	saveData = function(){
		console.log(this.evaluation.form_data.getWpFieldsData())
		if(this.jsDataService.get('saveUrl')){
			this.$scope.basicHttpConfigProcess({
				url: this.jsDataService.get('saveUrl'),
				method: 'POST',
				data: {
					criteria: this.evaluation.form_data.getCriteriaData(),
					fields: this.evaluation.form_data.getFieldsData(),
					total: this.evaluation.form_data.total,
					wp_fields: this.evaluation.form_data.getWpFieldsData(),
					version: this.evaluation.form_data.version,
					consolidation_version: this.evaluation.form_data.consolidation_version
				}
			}).then((response) => {

			});
	   }
	   return null;
   };

	change(){
		if(this.changeUrl !== ''){
			this.$scope.basicHttpConfigProcess({
				url: this.changeUrl,
				method: 'GET'
			});
		}
	}

	pendingChange(ev){
		if(this.pendingUrl !== ''){
			const confirmTexts = this.jsDataService.get('pendingConfirmTexts');
			const confirm = this.$mdDialog.confirm()
				.title(confirmTexts.title)
				.htmlContent(confirmTexts.content)
				.ariaLabel(confirmTexts.title)
				.targetEvent(ev)
				.ok(confirmTexts.ok)
				.cancel(confirmTexts.cancel);
			this.$mdDialog.show(confirm).then(() => {
				this.$scope.basicHttpConfigProcess({
					url: this.pendingUrl,
					method: 'GET',
					responseType: 'json'
				}).then((results) => {
					if(results.data.success){

					}
				});
			}, () => {});
		}
	}

    addNewCriteria = function() {
		const keys = Object.keys(this.evaluation.form_data.criteria);
		let lastIndex = keys.reduce((max, key) => {
			const match = key.match(/^cr(\d+)$/);
			return match ? Math.max(max, parseInt(match[1], 10)) : max;
		}, 0);
		const newIndex = lastIndex + 1;
		const newKey = `cr${newIndex}`;
		
		const data = {
			id: newKey,
			title: '',
			instruction: '',
			hidden: '',
			threshold: 0,
			max: 0,
			score: 0,
			newCriteria: true
		};
		this.evaluation.form_data.criteria[newKey] = new evlCriterionModel(data, this.$filter, this.jsDataService);
    };

    removeNewCriteria = function(ev, field) {
			const confirmTexts = this.jsDataService.get('removeConfirmTexts');
			const confirm = this.$mdDialog.confirm()
				.title(confirmTexts.title)
				.htmlContent(confirmTexts.content)
				.ariaLabel(confirmTexts.title)
				.targetEvent(ev)
				.ok(confirmTexts.ok)
				.cancel(confirmTexts.cancel);
			this.$mdDialog.show(confirm).then(() => {
				delete this.evaluation.form_data.criteria[field.id];
			}, () => {});


    };

	cancelChange(ev){
		if(typeof(this.cancelChangeUrl) !== 'undefined' && this.cancelChangeUrl !== ''){
			const confirmTexts = this.jsDataService.get('removeConfirmTexts');
			const confirm = this.$mdDialog.confirm()
				.title(confirmTexts.title)
				.htmlContent(confirmTexts.content)
				.ariaLabel(confirmTexts.title)
				.targetEvent(ev)
				.ok(confirmTexts.ok)
				.cancel(confirmTexts.cancel);
			this.$mdDialog.show(confirm).then(() => {
				this.$scope.basicHttpConfigProcess({
					url: this.cancelChangeUrl,
					method: 'GET',
					responseType: 'json'
				}).then((results) => {
					if(results.data.success){

					}
				});
			}, () => {});
		}
	}

	publishChange(ev){
		this.$mdDialog.show({
			controller: ["$scope", "$mdDialog", "jsDataService", this.publishChangeDialogCtrl],
			templateUrl: 'invitations/publish_change.html',
			parent: angular.element(document.body),
			targetEvent: ev,
			clickOutsideToClose:false,
			fullscreen: true,
			locals: {

			}
		}).then((results) => {
			if(typeof(this.item.status_url) !== 'undefined'){
				this.$scope.$root.basicHttpConfigProcess({
					url: this.item.status_url,
					method: 'POST',
					responseType: 'json',
					data: results
				});
			}
		}, () => {});

	}

	publishDialogCtrl($scope, $mdDialog, jsDataService){
		$scope.reject = function() {
			if(typeof(jsDataService.get('rejectUrl')) !== 'undefined' && jsDataService.get('rejectUrl') !== ''){
				$scope.$root.basicHttpConfigProcess({
					url: jsDataService.get('rejectUrl'),
					method: 'GET'
				}).then((response) => {
					if(response.data.success){

					}
				}, () => {});
			}
			$mdDialog.hide();
		};

		$scope.publish = function() {
			if(typeof(jsDataService.get('publishUrl')) !== 'undefined' && jsDataService.get('publishUrl') !== ''){
				$scope.$root.basicHttpConfigProcess({
					url: jsDataService.get('publishUrl'),
					method: 'GET'
				}).then((response) => {
					if(response.data.success){

					}
				}, () => {});
			}
			$mdDialog.hide();
		};
		$scope.close = function() {
			$mdDialog.cancel();
		};
	}

	publishChangeDialogCtrl($scope, $mdDialog, jsDataService){
		$scope.reject = function() {
			if(typeof(jsDataService.get('rejectChangeUrl')) !== 'undefined' && jsDataService.get('rejectChangeUrl') !== ''){
				$scope.$root.basicHttpConfigProcess({
					url: jsDataService.get('rejectChangeUrl'),
					method: 'GET'
				}).then((response) => {
					if(response.data.success){

					}
				}, () => {});
			}
			$mdDialog.hide();
		};

		$scope.publish = function() {
			if(typeof(jsDataService.get('publishChangeUrl')) !== 'undefined' && jsDataService.get('publishChangeUrl') !== ''){
				$scope.$root.basicHttpConfigProcess({
					url: jsDataService.get('publishChangeUrl'),
					method: 'GET'
				}).then((response) => {
					if(response.data.success){

					}
				}, () => {});
			}
			$mdDialog.hide();
		};
		$scope.close = function() {
			$mdDialog.cancel();
		};
	}
}